import React, { useEffect, useState } from 'react';

import {
  UnfoldMenu,
  UnfoldLink,
  LinkLabel,
  LinkIcon,
  ActiveLinkLine,
} from './styled';

import {
  EditBigIcon,
  SettingsIcon,
  SmartphoneIcon,
} from '@unfold/icon';

export const Menu: React.FC = () => {
  const [lineStyle, setLineStyle] = useState({});
  let timeout: number;
  const handleSetLineStyle = (): void => {
    timeout = setTimeout(() => {
      const activeLink = document.getElementsByClassName(
        'active-link'
      )[0] as HTMLElement;
      const activeLinkStyle = {
        top: `${activeLink ? activeLink.offsetTop : 0}px`,
      };
      setLineStyle(activeLinkStyle);
    });
  };

  useEffect(() => {
    handleSetLineStyle();

    return (): void => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <UnfoldMenu>
      <UnfoldLink
        to="/brand"
        onClick={handleSetLineStyle}
        activeStyle={{ opacity: 1 }}
        activeClassName="active-link"
      >
        <LinkLabel variant="Paragraph">Brand Kit</LinkLabel>
        <LinkIcon><EditBigIcon /></LinkIcon>
      </UnfoldLink>
      <UnfoldLink
        to="/stories"
        onClick={handleSetLineStyle}
        activeStyle={{ opacity: 1 }}
        activeClassName="active-link"
      >
        <LinkLabel variant="Paragraph">Stories</LinkLabel>
        <LinkIcon><SmartphoneIcon /></LinkIcon>
      </UnfoldLink>
      <UnfoldLink
        to="/preferences"
        onClick={handleSetLineStyle}
        activeStyle={{ opacity: 1 }}
        activeClassName="active-link"
      >
        <LinkLabel variant="Paragraph">Preferences</LinkLabel>
        <LinkIcon><SettingsIcon /></LinkIcon>
      </UnfoldLink>
      <ActiveLinkLine css={lineStyle} />
    </UnfoldMenu>
  );
};
